/**
 * Privacy Policy Page
 *
 * Public page rendering the full bQuest Privacy Policy.
 * All legal text is an exact replica of the approved prototype.
 * Split into section components to stay under 300-line file limit.
 */

import { useDocumentHead } from '@/shared/hooks/useDocumentHead';
import { PrivacyPolicyHeader } from '../components/privacy-policy/PrivacyPolicyHeader';
import { PrivacyPolicyIntro } from '../components/privacy-policy/PrivacyPolicyIntro';
import { InformationCollected } from '../components/privacy-policy/InformationCollected';
import { UseOfInformation } from '../components/privacy-policy/UseOfInformation';
import { DisclosuresAndTransfers } from '../components/privacy-policy/DisclosuresAndTransfers';
import { RemainingSections } from '../components/privacy-policy/RemainingSections';

export const PrivacyPolicyPage = () => {
  useDocumentHead({
    title: 'Privacy Policy | The bQuest',
    description: 'bQuest Privacy Policy — how we collect, use, and protect your personal information.',
  });

  return (
    <div className="bg-background">
      <PrivacyPolicyHeader />
      <main className="container py-16">
        <PrivacyPolicyIntro />
        <section className="py-16">
          <InformationCollected />
          <UseOfInformation />
          <DisclosuresAndTransfers />
          <RemainingSections />
        </section>
      </main>
    </div>
  );
};
